import { render, staticRenderFns } from "./r-query.vue?vue&type=template&id=fee05f8a&scoped=true&"
import script from "./r-query.vue?vue&type=script&lang=js&"
export * from "./r-query.vue?vue&type=script&lang=js&"
import style0 from "./r-query.vue?vue&type=style&index=0&id=fee05f8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee05f8a",
  null
  
)

export default component.exports